import { useState } from "react";
import TOSModal from "../components/TOSModal";
import { getLoggedinUser } from "../userStore";

export const AppFooter = (props) => {
  const [showTosModal, setShowTosModal] = useState(false);
  const [isFooterOpen, setIsFooterOpen] = useState(false);
  const user = getLoggedinUser();

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      setShowTosModal(true);
    }
  };

  const toggleFooter = () => {
    setIsFooterOpen(!isFooterOpen);
  };
  const [checkMobile, setCheckMobile] = useState(
    window.innerWidth < 868 ? true : false
  );

  //check on resizing
  window.addEventListener("resize", () => {
    if (window.innerWidth < 868) {
      setCheckMobile(true);
    } else {
      setCheckMobile(false);
    }
  });
  return (
    <>
      {showTosModal && (
        <TOSModal
          userData={[]}
          setUserData={() => {}}
          setShowTosModal={setShowTosModal}
          agreementType="agreed"
        />
      )}

      {/* Mobile Toggle Button (only on mobile) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 flex justify-center z-40">
        <button
          onClick={toggleFooter}
          className="bg-blue-600 text-white p-2 rounded-t-lg shadow-lg"
          aria-expanded={isFooterOpen}
          aria-label={isFooterOpen ? "Close footer" : "Open footer"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-6 w-6 transition-transform duration-300 ${
              isFooterOpen ? "rotate-180" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 15l7-7 7 7"
            />
          </svg>
        </button>
      </div>
      {!checkMobile && (
        <div className=" flex justify-between gap-2 ">
          <p>© 2025 DocToMe Inc. All rights reserved.</p>
          <div className="text-red-800 font-bold w-[60%]">
            <img src="" alt="" />
            <p>
              If this is an urgent or emergent patient care issue, please call{" "}
              <strong>911</strong> or go to the nearest emergency room.
            </p>
          </div>
          {user && (
            <p
              className="text-blue-600 hover:underline"
              role="button"
              tabIndex={0}
              onClick={() => setShowTosModal(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setShowTosModal(true);
                }
              }}>
              Term & Conditions
            </p>
          )}
        </div>
      )}

      {/* Footer Content */}
      <footer
        className={`
          bg-white border-t border-gray-200
          lg:static lg:translate-y-0
          fixed bottom-0 left-0 right-0 z-30
          transition-transform duration-300 ease-in-out lg:hidden md:hidden
          ${
            isFooterOpen ? "translate-y-0" : "translate-y-full lg:translate-y-0"
          }
        `}>
        <div className="flex flex-col lg:flex-row justify-between items-center gap-4 p-4 text-sm max-w-6xl mx-auto">
          {/* Copyright text */}
          <p className="text-center lg:text-left order-1 lg:order-none">
            © 2025 DocToMe Inc. All rights reserved.
          </p>

          {/* Emergency info */}
          <div className="flex items-center gap-2 bg-red-50 px-3 py-1 rounded-md order-2 lg:order-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-red-600"
              viewBox="0 0 20 20"
              fill="currentColor">
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <span className="font-semibold text-red-800">
              <p>
                If this is an urgent or emergent patient care issue, please call{" "}
                <strong>911</strong> or go to the nearest emergency room.
              </p>
            </span>
          </div>

          {/* Terms & Conditions */}
          {user && (
            <button
              className="text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded px-2 py-1 transition-colors order-3 lg:order-none"
              onClick={() => setShowTosModal(true)}
              onKeyDown={handleKeyDown}
              aria-label="View Terms and Conditions">
              Terms & Conditions
            </button>
          )}
        </div>
      </footer>
    </>
  );
};
